module.exports = __webpack_public_path__ + "static/logo-2c18021c514eb7c685a89526772680aa.jpeg";